import { isServiceAccount } from "helpers/helpers";
import { OrdersService } from "services/orders-service";
import { UserPermissions } from "services/user-permissions";

export async function isProcurement(){
    const members = await OrdersService.instance.getProcurementHardwareTeamMembers();
    const username = UserPermissions.instance.username;
    return(
        members.includes(username) || isServiceAccount(username)
    )
}